<nz-form-item>
  <nz-form-control [nzValidateStatus]="onValidation ? 'validating' : errorType" [nzErrorTip]="errorMessage">
    <nz-input-group [nzAddOnAfter]="addOnAfterTemplate" [nzPrefixIcon]="prefixIcon">
      <input nz-input [id]="code" type="{{inputType}}" [(ngModel)]="value" (change)="inputChanged()"
        (keyup)="inputTyped()" [attr.maxlength]="maxLength" [disabled]="disabled" placeholder="{{title}}"
        autocomplete="off" />
    </nz-input-group>
    <ng-template #addOnAfterTemplate>
      <i class="{{icon}}" (click)="togglePwdView()"></i>
    </ng-template>
  </nz-form-control>
</nz-form-item>